export default "__VITE_ASSET__C0v6BRwd__"